export default "/_next/static/fonts/tt_norms_pro_normal_italic-d09e427fc86e445e6b3f72158eab6c88.woff";